import React, { Component } from 'react'
import { connect } from 'react-redux'
import Api from '../services/Api'
import ApiCaller from '../services/ApiCaller';
import { call } from 'redux-saga/effects'
import {
  Panel, FormControl, Col,
  PanelContainer, Row, Button
} from '@sketchpixy/rubix'
import {
  DEFAULT_DATE_TIME_FORMAT
} from '../utils/index'
import moment from 'moment';
import LoadingContainer from "../components/LoadingContainer";

const api = Api.apiCreate(process.env.API_URL)

class ListDbqs extends Component {
  constructor (props) {
    super(props)
    this.state = {
      value: "21-0960M-2",
      file: "",
      fileLink: "",
      message: "",
      loading: false,
      success: false,
      fields: [],
      action: "removeHidden",
      dbqList: {
        "21-0960M-2": "Ankle Disabilities",
        "21-0960L-1": "Asthma, Sarcoidosis, etc.",
        "21-0960M-14": "Back Disabilities",
        "21-0960J-4": "Bladder Disabilities, Urinary Tract Infection, etc.",
        "6354A": "Chronic Fatigue Syndrome",
        "21-0960E-1": "Diabetes",
        "21-0960C-4": "Diabetic Neuropathy",
        "21-0906-P1": "Eating Disorder",
        "21-0960M-4": "Elbow Disabilities",
        "21-0960C-7": "Fibromyalgia",
        "21-0960G-1": "GERD, Hiatal Hernia, etc.",
        "21-0960M-3": "Gout",
        "21-0960M-7": "Hand and Fingers",
        "21-0960A-4": "Heart Disabilities",
        "21-0960H-2": "Hemorrhoids",
        "21-0960G-5": "Hepatitis",
        "21-0960M-8": "Hip Disabilities",
        "21-0960I-2": "Hiv",
        "21-0960G-3": "IBS",
        "21-0960J-1": "Kidney Disease, Kidney Stones, etc",
        "21-0960M-9": "Knee Disabilities",
        "21-0960J-2": "Male Reproductive Organ",
        "21-0960P-2": "Mental Disorders other than PTSD",
        "21-0960C-8": "Migraines, Tension Headaches, etc.",
        "21-0960C-9": "Multiple Sclerosis",
        "8108A": "Narcolepsy",
        "21-0960M-13": "Neck Disabilities",
        "21-0960C-10": "Nerve Disabilities",
        "21-0960M-6": "Pes Planus or Plantar Fasciitis",
        "21-0960P-3": "PTSD",
        "21-0960F-1": "Scars",
        "21-0960C-11": "Seizure Disorders",
        "21-0960M-12": "Shoulder Disabilities",
        "21-0960N-4": "Sinusitis",
        "21-0960F-2": "Skin Diseases",
        "21-0960L-2": "Sleep Apnea",
        "21-0960A-2": "Varicose Veins, Peripheral Vascular Disease, etc.",
        "21-0960M-16": "Wrist Conditions",
      },
    };
  }

  componentDidMount() {
    const { dbqList } = this.state
    Object.keys(dbqList).map(function(key, val) {
        console.log(dbqList[key])
    })
    // this.partial()
}

handleChange = (event) => {
    this.setState({ value: event.target.value, fileLink: "", message: "" });
};

handleFile = (event) => {
 let file = event.target.files[0];
 this.setState({ file });
};

// partial = () => {
//   let token = localStorage.getItem('login_token');
//     let headers = {"Content-Type": "application/json"};
//     // headers["Authorization"] = `Bearer ${token}`
//     fetch(process.env.API_URL+"/patients/partial/21-0960M-6/be543aca-ba71-11ec-be4d-02bf4ef5301b", {headers})
//     .then(response => response.json())
//     .then(data => {    
//       console.log("DONE DONEE")
//     })
//     .catch((error) => {
//       console.error('Error:', error);
//     });
// }

testFile = () => {
    const { value, file, action } = this.state
   
    if (action === "removeHidden" || (action === "validate" && value)) {
        this.setState({ loading: true, message: "", fields: [] });
       let token = localStorage.getItem('login_token');
       let headers = {"Content-Type": "multipart/form-data"};
       // let headers = {};
       headers["Authorization"] = `Bearer ${token}`
   
       Object.keys(headers)
         .forEach( function(k) { 
            if (k.toLowerCase()==='content-type') delete headers[k] 
         })
       const fd = new FormData();
       fd.append('dbqFile', file);
       fd.append('dbqForm', value);
       fd.append('action', action);
   
       fetch(process.env.API_URL+"/patients/compatible", {method: 'POST', body: fd, headers} )
       .then(response => response.json())
       .then(data => {
        this.setState({ fileLink: data.filePath ? data.filePath: "", loading: false, success: data.success, message: data.message, fields: data.fields ? data.fields : []}) 
       })
       .catch(err => {
            this.setState({ loading: false, message: err.message });
           console.error(err)
        });
    } else {
        alert("Please select DBQ for which file is to upload")
    }
   
   };

viewQuestion = (listItem) => {
  this.setState({questions: listItem.questions})
  window.scrollTo({top: 0, left: 0, behavior: 'smooth' });
}
  render () {
    const { dbqList, value, fileLink, loading, success, message, fields } = this.state
    let list = Object.keys(dbqList).map((item, i) => {
      return (
        <option key={i} value={item}>{dbqList[item]}</option>
      )
    }, this);
    
    return (
      <div className={'home-containers'} >
          <Row>
            <div className="col-xs-6">
            
            <FormControl autoFocus  disabled ={this.state.action === "removeHidden"}
                type="select"
                componentClass="select"
                key="11"
                className='required'
                name="sugardbqlist"
                onChange={this.handleChange}
                value={value}
                style={{margin: '0', border: "1px solid #797979", width: '60%'}}
                >
                {list}
            </FormControl>            
            </div>
          </Row>
          <br />
          <Row>
          <div className="col-sm-2" onClick={() => this.setState({action: "removeHidden"})}><input type="radio" name="action" checked={this.state.action === "removeHidden"} style={{height: 20, width: 20}} /><span style={{marginLeft: 15, cursor: 'pointer'}}>Show Hidden Fields</span></div>
          <div className="col-sm-2" onClick={() => this.setState({action: "validate"})}><input type="radio" name="action" checked={this.state.action === "validate"} style={{height: 20, width: 20}} /><span style={{marginLeft: 15, cursor: 'pointer'}}>Validate DBQ</span></div>
          </Row>
          <br />
          <Row>
            <div className="col-xs-3">
                <input type="file" id="avatar" name="avatar" onChange={this.handleFile} />
            </div>
            <div className="col-xs-3">
                {/* <input type="button" id="btn" name="save" onClick={this.testFile} >Go</input> */}
                <Button
                    sm
                    type='button'
                    bsStyle='success'
                    // className="next-btn big-btn"
                    // style={{width: "260"}}
                    onClick={this.testFile}>Go
                </Button>
            </div>
            <div className="col-xs-1">
            {loading && <LoadingContainer/>}
            </div>
          </Row>
          <br /> 
          <Row>
          <div className="col-xs-12">
            {
                message && <p style={success? {color: 'green', fontWeight: 'bold', fontSize: '20'} :{color: 'red', fontSize: '20'}}>{message}</p>
            }
            {
                fileLink && <object width="100%" height="600" data={fileLink} type="application/pdf">   </object>
            }
          </div>
          <div className="col-xs-12">
          <div className="col-xs-6">
          {fields && fields.length>0 &&<h3>Fastvet DBQ Field Names are not in DBQ file:</h3>}
          {fields && fields.length>0 && fields.map(name => {
            return <p>{name}</p>
          }) }
          </div>
          <div className="col-xs-6">
          {/* {uploadedFileFields && uploadedFileFields.length>0 && <h3>Uploaded DBQ Field Names</h3>}
          {uploadedFileFields && uploadedFileFields.length>0 && uploadedFileFields.map(name => {
            return <p>{name}</p>
          }) } */}
          </div>
          </div>
          </Row>       
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
})

const mapStateToProps =
  ({
     login: {
       role
     }
   }) => ({
    role
  })

export default connect(mapStateToProps, mapDispatchToProps)(ListDbqs)
